export const az = {
    "n1": "Əsas səhifə",
    "n2": "Sifariş verin",
    "n3": "əməliyyat",
    "n4": "komanda",
    "n5": "mənim",
    "t1": "nəsə səhv getdi",
    "t2": "Uğurla kopyalandı",
    "t3": "Zəhmət olmasa məlumatı tam doldurun",
    "t4": "Yüklənir...",
    "t5": "Giriş uğurlu oldu",
    "t6": "Təqdim etmək üçün bal 3-dən çox olmalıdır",
    "t7": "Təqdimat uğurlu oldu",
    "t8": "Balansın qeyri-kafi, qəbul etmək mümkün deyil",
    "t9": "Təqdim edilmədi",
    "t10": "Zəhmət olmasa əvvəlcə ünvanı bağlayın və siz şəxsi mərkəzin səhifəsinə yönləndiriləcəksiniz.",
    "t11": "Ünvan bağlandı, onu dəyişdirmək üçün müştəri xidməti ilə əlaqə saxlayın.",
    "t12": "Modifikasiya uğurlu",
    "t13": "Dəyişiklik uğursuz oldu",
    "t14": "Şifrənizi dəyişmək üçün müştəri xidməti ilə əlaqə saxlayın",
    "t15": "Parol formatı xətası",
    "t16": "Uğurla geri çəkilin",
    "t17": "Çıxarıla bilən maksimum məbləğ",
    "t18": "Minimum geri çəkilmə",
    "t19": "İki parol uyğun gəlmir",
    "t20": "Məsləhətlər",
    "t21": "Hazırda tullanmaq mümkün deyil",
    "t22": "Parol formatı xətası",
    "t23": "Qeydiyyat uğurlu oldu",
    "t24": "Zəhmət olmasa ərazi kodunu daxil edin",
    "t25": "Artıq yox",
    "l1": "Dil",
    "l2": "Zəhmət olmasa hesab nömrəsini daxil edin",
    "l3": "Zəhmət olmasa parol daxil edin",
    "l4": "xatırlayın",
    "l5": "Daxil ol",
    "l6": "Qeydiyyata gedin",
    "l7": "Hesab yoxdur",
    "l8": "Mobil telefon nömrəsi",
    "l9": "Ləqəb",
    "l10": "parol",
    "l11": "Şifrəni təsdiqləyin",
    "l12": "Dəvət kodu",
    "l13": "Qeydiyyatdan keçin",
    "l14": "Artıq hesabınız var",
    "l15": "Girişə keçin",
    "l16": "Zəhmət olmasa 6-16 rəqəmli parol daxil edin",
    "bz1": "kömək",
    "bz2": "Tez-tez verilən suallar",
    "bz3": "ticarət qaydaları",
    "bz4": "Necə pul çıxarmaq olar",
    "bz5": "Necə doldurmaq olar",
    "bz6": "1. Amazon Review RoBoT nədir?",
    "bz7": "Amazon Review RoBoT, bütün dünyada Amazon Review RoBoT onlayn mağaza tacirlərinə daha çox sifariş satışı əldə etməyə və Amazon Review RoBoT onlayn mağazalarına baxış məlumatlarını artırmağa kömək edən marketinq təşviqi şirkətidir. Biz Amazon Review RoBoT, tacirlər və istehlakçılar arasında üçtərəfli gəlirli marketinq və təşviqat modelinin yaradılmasına sadiqik. Ən son P2P blockchain texnologiyası ilə birlikdə istehlakçılar və tacirlər USDT (TRC20, ERC20) vasitəsilə tez bir zamanda bağlanır. Qeydiyyatdan keçmiş istifadəçilər sifarişlər üzrə komissiya ala bilər, tacirlər isə öz mağazalarının satış məlumatlarını artıra bilərlər. İnternet blokçeyn modelində ən son mənfəət modelidir!",
    "bz8": "2. Amazon Review RoBoT necə işləyir?",
    "bz9": "Amazon Review RoBoT-dan gündəlik rəylər göstərir ki, təkmilləşdirilməyə ehtiyacı olan məhsullar Amazon Review RoBoT-da satılır. İstifadəçilər sadəcə sifarişin üzərinə asanlıqla klikləməlidirlər və sistem avtomatik olaraq sifariş abunəsi yaradır. İstifadəçilər sifariş məbləğini blockchain USDT vasitəsilə ödəyir və gündəlik komissiya alırlar.",
    "bz10": "3.Niyə eyni valyutanın qiymətləri iki əməliyyatda fərqli olur?",
    "bz11": "Qiymət fərqləri valyutaların sərbəst dövriyyəsi üçün əlverişli olmayan bütün amillər, o cümlədən valyuta köçürmələrinin sürəti, şəbəkə şərtləri, valyutaya giriş məhdudiyyətləri, müxtəlif regionlardakı insanlar tərəfindən valyuta tanınması, hətta birjalar tərəfindən təmin edilən ticarət cütlərinin növləri, əməliyyatlar və s. Buna görə də eyni valyutanın müxtəlif əməliyyatlarda qiymət fərqləri ola bilər.",
    "bz12": "4. İnvestisiya mənfəəti?",
    "bz13": "Aldığınız məhsulun qiyməti nə qədər yüksək olsa, sifarişdən əldə etdiyiniz qazanc da bir o qədər yüksək olar. Eyni zamanda, Amazon Review RoBoT təsadüfi olaraq böyük komissiya sifarişlərini paylayır.",
    "bz14": "Sistem hər gün avtomatik olaraq 60 məhsul sifarişi yaradır və istifadəçilərə paylayır. İstifadəçilər hər sifariş üçün ödənişi USDT vasitəsilə tamamlayır və 0,6% komissiya alırlar. Böyük komissiya sifarişləri təsadüfi olaraq təyin edilir.",
    "bz15": "USDT 60 sifarişdən sonra geri götürülə bilər. (60 sifariş tamamlanmazsa, günün qalan sifarişlərinə qədər sistem avtomatik olaraq dayanacaq)",
    "bz16": "Hər bir hesab yalnız bir USDT hesabına bağlana bilər. Səhv baş verərsə, müştəri xidməti ilə əlaqə saxlayın.",
    "bz17": "Gündəlik sifarişlərin çatdırılmasını tamamladıqdan sonra pulu normal şəkildə çıxara bilərsiniz. Pul çəkilməyə başladıqdan sonra 24 saat ərzində gələcək və heç bir geri çəkilmə limiti yoxdur.",
    "bz18": "Doldurmadan əvvəl, lütfən, pul çıxarma ünvanınızı (TRC-20-ni dəstəkləyir) USDT ünvanını bağlayın. Siz APP-də və ya veb-səhifədə doldurma üzərinə klikləyərək doldurmaq üçün istifadə etdiyiniz blokçeyn (TRC-20) seçə bilərsiniz.",
    "bz19": "Əlaqədar hesablar arasında qarşılıqlı doldurmaya və ya qarşılıqlı köçürməyə icazə verilmir. Bu, zərərli sifariş tutma davranışıdır və platformanın iş qaydalarına ciddi təsir göstərir. Belə davranış aşkar edilərsə, sistem dərhal hesabı donduracaq və işi diskvalifikasiya edəcək.",
    "ty1": "OK",
    "ty2": "Ləğv et",
    "ty3": "Təqdim et",
    "ty4": "TRC20 ünvanı",
    "ty5": "ERC20 ünvanı",
    "s1": "Kumulyativ gəlir",
    "s2": "xidmət",
    "s3": "Haqqımızda",
    "s4": "kömək",
    "s5": "Tərəfdaşlar",
    "s6": "xidmətlərim",
    "d1": "Tamamlanmadı",
    "d2": "Tamamlandı",
    "d3": "Hələ məlumat yoxdur",
    "d4": "Sifariş nömrəsi",
    "d5": "ticarət saatları",
    "d6": "Məbləğ",
    "d7": "Cari tapşırıqların sayı",
    "d8": "gözlənilən gəlir",
    "d9": "Hələ lazımdır",
    "d10": "Reytinq",
    "j1": "Hesab balansı",
    "j2": "Ticarət təqdimatı",
    "j3": "Amazon Review RoBoT, Amazon Review RoBoT tərəfindən satılan və təkmilləşdirilməyə ehtiyacı olan məhsulları nümayiş etdirmək üçün hər gün Amazon Review RoBoT-dan rəylərdən istifadə edir. İstifadəçilər yalnız sifarişin üzərinə klikləməlidir və sistem avtomatik olaraq sifariş imzası yaradacaqdır. İstifadəçilər sifariş məbləğini USDT blockchain vasitəsilə ödəyirlər və hər dəfə 0,6%-dən çox komissiya ala bilərlər və sistem təsadüfi olaraq böyük mükafat sifarişlərini paylayır.",
    "j4": "Uyğunlaşmağa başlayın",
    "j5": "Bugünkü qazanc",
    "j6": "Tamamlandı",
    "j7": "Tapşırıqların ümumi sayı",
    "td1": "balans",
    "td2": "komissiya",
    "td3": "almaq",
    "td4": "insanların ümumi sayı",
    "td5": "İstifadəçi",
    "td6": "töhfə verin",
    "td7": "Kəmiyyət",
    "td8": "Vəziyyət",
    "g1": "Nağd pul çıxarın",
    "g2": "Yenidən doldurun",
    "g3": "Dostları dəvət edin",
    "g4": "İndi dəvət et",
    "g5": "Dostlarınızın qeydiyyatdan keçdikdən sonra əldə etdiyi hər qazanc üçün siz müvafiq komissiya alacaqsınız.",
    "g6": "şəxsi məlumat",
    "g7": "Fond təfərrüatları",
    "g8": "Rekord doldurma",
    "g9": "Çıxarma qeydləri",
    "g10": "Dil",
    "g11": "Çıxın",
    "g12": "Çıxmaq istədiyinizə əminsiniz?",
    "yh1": "İstifadəçi məlumatı",
    "yh2": "Dəyişdirin",
    "yh3": "parametrlər",
    "yh4": "telefon",
    "yh6": "Orijinal parol",
    "yh7": "yeni parol",
    "mx1": "Komissiya yığımı",
    "mx2": "gəlir",
    "mx3": "Çıxarma rədd edildi",
    "mx4": "vaxt",
    "mx5": "Uğurlu doldurun",
    "mx6": "Rədd edildi",
    "mx7": "Gözlənir",
    "mx8": "Çıxarma ünvanı",
    "mx9": "mövcud balans",
    "mx10": "Faktiki gəliş",
    "mx11": "Zəhmət olmasa çıxarma məbləğini daxil edin",
    "cz1": "Depozit ünvanı yalnız ERC20-ni dəstəkləyir və minimum depozit məbləği 20USDT-dir.",
    "cz2": "Kopyalayın",
    "cz3": "Fiat valyuta seçimi",
    "cz4": "ödəmək",
    "cz5": "Depozit ünvanı yalnız TRC20-USDT-ni dəstəkləyir və minimum depozit məbləği 20USDT-dir.",
    "cz6": "Depozit ünvanı yalnız ERC20-ni dəstəkləyir və minimum depozit məbləği 20USDT-dir.",
    "qy1": "ərazi kodu",
    "yq1": "Dostları dəvət edin",
    "yq2": "Dəvət kodu",
    "yq3": "Dostlarınızı dəvət edin və böyük faydalardan yararlanın",
    "yq4": "Gedin dəvət edin",
    "zf1": "Doldurma üsulu",
    "zf2": "Lütfən, doldurma üsulu seçin",
    "zf3": "ticarət valyutaları",
    "zf4": "ticarət şəbəkəsi",
    "zf5": "Ticarətə get",
    "zf6": "Uğurla kopyalandı",
    "zf7": "ticarət valyutaları",
    "zf8": "Zəhmət olmasa istifadə edin",
    "zf9": "Doldurmanı tamamlamaq üçün pulu aşağıdakı ünvana köçürün.",
    "zf10": "Əməliyyat valyutası",
    "zf11": "Kopyalayın",
    "zf12": "Zəhmət olmasa ünvanı diqqətlə yoxlayın. Əgər onu səhv köçürsəniz, onu geri ala bilməyəcəksiniz.",
    "zf13": "Gəliş vaxtı",
    "zf14": "Təxminən 1-5 dəqiqə",
    "zf15": "Minimum doldurma məbləği",
    "a1": "Mağaza Marketinq Mərkəzi",
    "a2": "Amazon Market Robot mağaza marketinq mərkəzi, tacirlərə qısa müddət ərzində öz məhsullarının satışlarını və tərif dərəcələrini sürətlə artırmağa, bununla da məhsulların çəkisini artırmağa və onların məruz qalmasını daha da artırmağa kömək etmək üçün nəzərdə tutulmuş tamamilə yeni bölmədir; istifadəçilər müxtəlif tapşırıqları yerinə yetirməklə tacirlərə kömək edir və müvafiq mükafatlar alır, beləliklə, hər iki tərəf üçün qalib-qazan vəziyyətinə nail olurlar.",
    "a3": "Hazırda sistemin 30 milyon istifadəçisi və 5 milyon taciri var və hər gün platformada təbliğ olunan məhsulların sayı 70 milyona çatır; bəzi ticarət məhsulları marketinq mərkəzi sisteminə qoşularaq mağaza satışlarını 60% artırıb; marketinq mərkəzi sisteminin platforma istifadəçiləri isə sadəcə sifarişin üzərinə klikləməlidirlər və marketinq mərkəzi sistemi avtomatik olaraq sifariş imzası yaradacaq. İstifadəçi sifariş məbləğini əvvəlcədən ödədikdən sonra virtual əməliyyat başa çatır və vəsait dərhal istifadəçi hesabına qaytarılır. Hər dəfə 0,6%-dən çox əlavə komissiya əldə etmək olar. Sistem həmçinin istifadəçinin komissiyasını artırmaq üçün təsadüfi olaraq böyük mükafat sifarişləri ayıracaq.",
    "a4": "Amazon Market Robot istifadəçilərin və tacirlərin ehtiyaclarına böyük əhəmiyyət verir və marketinq mərkəzi sistemini optimallaşdırmağa və təkmilləşdirməyə davam edir.",
    // 客服
    "kf1": "Onlayn müştəri xidməti",
    "kf2": "Əl ilə müştəri xidməti pul çıxarma",
    "kf3": "Pul çıxarmaq üçün əl ilə müştəri xidməti ilə əlaqə saxlamaq üçün buraya klikləyin",
    "kf4": "Əl ilə müştəri xidməti pul yükləmə",
    "kf5": "Pul yükləmək üçün əl ilə müştəri xidməti ilə əlaqə saxlamaq üçün buraya klikləyin",
    // 支付选项弹窗
    "zf16": "Bank kartı əməliyyatları üçün müştəri xidməti ilə əlaqə saxlayın",
    "zf17": "Müştəri xidməti ilə əlaqə saxlayın"
  }
  